import { handleActions } from "redux-actions";

const assetModalReducer = handleActions(
  {
    ASSET_MODAL: {
      CLOSE: () => ({
        isAssetModalOpen: false,
      }),
      OPEN: () => ({
        isAssetModalOpen: true,
      }),
    },
  },
  {},
  { namespace: "_" }
);

export default assetModalReducer;
